<div *ngFor="let file of files">
  <app-attachment-file-view-card [file]="file" [isReadonly]="isReadonly"> </app-attachment-file-view-card>
</div>
